import { createSelector } from 'reselect';
import { basketProductsSelector } from './basketProductsSelector';

const basketItemCountSelector = createSelector(basketProductsSelector, items => ({
  itemCount: items.reduce((acc, item) => acc + item.quantity, 0),
}));

export default basketItemCountSelector;
